/**
 * THIS FILE WILL WORK AS THE START UP FILE FOR THE APPLICATION
 * THIS WILL CONTAIN THE HEADER AND FOOTER AND COMMON ROUTE IMPORT
 */
import React from "react";

import RoutesSetup from "VENDOR/Routes/Routes";
import Footer from "VENDOR/Footer/Footer";
import config from "config";
import Header from "VENDOR/Header/Headers";

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  

  render() {
    if (config.instructorInfo === undefined || config.instructorInfo === "") {
      return <div className="App"> Hello </div>;
    } else {
      return (
        <div className="App">
          <Header />
          <RoutesSetup />
          <Footer />
        </div>
      );
    }
  }
}

export default App;
